import { Link } from 'react-router-dom';

interface ProjectLinkProps {
  projectUuid: string;
  label?: string | number;
  target?: string;
}

export default function ProjectLink({
  label,
  projectUuid,
  target = '_self',
}: ProjectLinkProps) {
  return (
    <Link to={`/project_details/${projectUuid}`} target={target}>
      {label || projectUuid}
    </Link>
  );
}
